import axios from 'axios';
import { useEffect } from 'react';
import { Loading } from 'shell/components';

const APILaunch = (props) => {
    useEffect(() => {
        const params = new URLSearchParams(props.location.search);
        const code = params.get('code');
        const state = params.get('state');
        localStorage.removeItem('auth_token');

        if (code) {
            (async () => {
                const launchAPI = await axios.post('/get-user-context', {
                    code: code,
                    state,
                    course_id: localStorage.getItem('course_id'),
                });
                if (!launchAPI?.access_token && !launchAPI?.access) {
                    window.location.href = '/lti-incomplete';
                } else {
                    localStorage.setItem('access_token', launchAPI.access_token);
                    localStorage.setItem('refresh_token', launchAPI.refresh_token);
                    localStorage.setItem('auth_token', launchAPI.token);

                    window.location.href = '/';
                }
            })();
        } else {
            (async () => {
                const authorizeURL = await axios.post('/get-access-token');
                window.location.href = authorizeURL;
            })();
        }
    }, [props.location.search]);

    return <Loading />;
};

export default APILaunch;
